import React, { useState, useContext, forwardRef, useImperativeHandle } from 'react';
import { useForm } from 'react-hook-form';
import { v4 as uuid } from 'uuid';

import FormData from './Form.context';

import Button from '../../common/Button.react';

import Base from './Base.form';
import Email from './Email.form';
import Select from './Select.form';
import Datepicker from './Datepicker.form';
import Url from './Url.form';
import Phone from './Phone.form';

const Form = forwardRef(({ data, submitBtn = null, deleteBtn = null }, ref) => {
	const [id] = useState(uuid());

	// const { register } = useContext(FormData);

	const form = useForm({ mode: 'onChange', reValidateMode: 'onBlur' });
	const { handleSubmit, reset, register, formState } = form;

	useImperativeHandle(ref, () => ({

		handleReset(data) {
			reset(data);
		},

	}));

	return (
		<div>
			<FormData.Provider value={form}>
				<form className='form'>
					{ data?.map(x => {

						const type = x.type || 'input';
						const required = x.required || false;

						if (type === 'url')
							return (
								<Url
									name={x.name || 'url'}
									required={required}
									key={x.name || 'url'}
								/>
							);

						const name = x.name || x;

						if (type === 'date')
							return (
								<Datepicker
									name={name}
									required={required}
									key={name}
								/>
							);

						if (type === 'email')
							return (
								<Email
									name={name}
									required={required}
									key={name}
								/>
							);

						if (type === 'phone')
							return (
								<Phone
									name={name}
									required={required}
									key={name}
								/>
							);

						if (type === 'select')
							return (
								<Select
									name={name}
									required={required}
									key={name}
								/>
							);

						return (
							<Base
								type={type}
								name={name}
								required={required}
								label={x.label || null}
								key={name}
							/>
						);
					})}

					<input
						name='apiID'
						value={id}
						ref={register}
						style={{ display: 'none' }}
					/>
				</form>

				<div className='card__footer'>
					{ deleteBtn && !deleteBtn.hidden &&
						<Button
							type='delete'
							label={deleteBtn.label || 'Remove'}
							requireConfirmation
							confirmationMessage={deleteBtn.confirmationMessage || 'Are you sure?'}
							apiID='delete'
							onClick={() => {
								if (deleteBtn.onDelete)
									deleteBtn.onDelete();
							}}
						/>
					}
					{ submitBtn && !submitBtn.hidden &&
						<Button
							type='primary'
							disabled={!formState.isValid}
							label={submitBtn.label}
							apiID={id}
							onClick={handleSubmit(submitBtn.onSubmit)}
						/>
					}
				</div>
			</FormData.Provider>
		</div>
	);
});

export default Form;
